import { CardPaymentsGqlMutations } from './mutations'
import { CardPaymentsGqlQueries } from './queries'

export const CardPaymentsGql = {
  Queries: CardPaymentsGqlQueries,
  Mutations: CardPaymentsGqlMutations,
}
